import { render, staticRenderFns } from "./savedAddressItem.vue?vue&type=template&id=9f53b05a&scoped=true&"
import script from "./savedAddressItem.vue?vue&type=script&lang=js&"
export * from "./savedAddressItem.vue?vue&type=script&lang=js&"
import style0 from "./savedAddressItem.vue?vue&type=style&index=0&id=9f53b05a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f53b05a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VFlex,VLayout,VRadio,VRadioGroup})
